import Helpers from "../../../../../Site/gulp/scripts/typescript/modules/helpers";

declare var popups: any;
declare var Mustache: any;

export default class ArticleLoader {
	 
	private nextPage = this.getNextPage();
	private articleEndpoint = '/blog/api/home/posts';
	private articleLoaderElement = document.querySelector('.js-article-loader');

	constructor() {
		this.attachClickEvent();
	}

	private attachClickEvent() {
		if (!this.articleLoaderElement) {
			return; 
		}
		this.articleLoaderElement.addEventListener('click', (event: Event) => this.handleLoadArticleClick(event));
	}

	private handleLoadArticleClick(event: Event) {

		event.preventDefault();

		this.loadArticles()
			.then((articlesResponse) => {
				const articlesTemplated = this.templateArticles(articlesResponse);
				const articleListElement = document.querySelector('.js-article-loader-list');
				if (articleListElement) {
					articleListElement.insertAdjacentHTML("beforeend", articlesTemplated);
					const allItems = articleListElement.querySelectorAll('.c-article-list__list-item');
					const firstNewItem = allItems[allItems.length - articlesResponse.ShowMoreBlogPosts.length] as HTMLElement;
					if (firstNewItem) {
						firstNewItem.setAttribute('tabindex', '-1');
						firstNewItem.focus();
					}
				}

				this.nextPage = articlesResponse.CurrentPage + 1;

				if (articlesResponse.IsLastPage) {
					this.articleLoaderElement.parentNode.removeChild(this.articleLoaderElement);
				}

				this.updateURLWithCurrentPage(articlesResponse.CurrentPage);
				this.updateButtonURLWithNextPage(articlesResponse.CurrentPage + 1);
				this.updateCanonicalLink(articlesResponse.CurrentPage);

				popups.allow = true;
				popups.close();

			})
			.catch(function () {
				popups.allow = true;
				popups.close();
				popups.confirm('Error', 'Sorry, there was a problem retrieving blog articles. Please try again later.', '', true);
			});
	}

	private loadArticles() {

		popups.loader();

		return fetch(this.articleEndpoint + '?page=' + this.nextPage + '&ctaBlockVisible=' + this.isCTABlockVisible())
			.then((response) => {
				if (response.ok) {
					return response.json();
				} else {
					throw new Error(response.statusText);
				}
			});

	}

	private templateArticles(articlesResponse) {
		let articlesTemplated = "";
		const template = document.querySelector('#articleCardTemplate').innerHTML;
		for (let i = 0, len = articlesResponse.ShowMoreBlogPosts.length; i < len; i++) {
			const articleModel = articlesResponse.ShowMoreBlogPosts[i];
			articleModel.BlogPostLoadedViaAjax = true;
			articlesTemplated += '<li class="c-article-list__list-item">' + Mustache.render(template, articleModel) + '</li>';
		}
		return articlesTemplated;
	}

	private isCTABlockVisible() {
		return document.querySelector('.js-blog-cta-block') ? 'true' : 'false';
	}

	private getNextPage() {
		let page = 2;
		const queryPage = Helpers.getParameter('page');
		if (queryPage) page = parseInt(queryPage) + 1;
		return page;
	}

	private updateURLWithCurrentPage(currentPage) {
		const newUrl = Helpers.updateQueryStringParameter(window.location.href, 'page', currentPage);
		history.pushState(null, null, newUrl);
	}

	private updateButtonURLWithNextPage(nextPage) {
		const updatedHref = Helpers.updateQueryStringParameter(this.articleLoaderElement.getAttribute('href'), 'page', nextPage);
		this.articleLoaderElement.setAttribute('href', updatedHref);
	}

	private updateCanonicalLink(page: string) {
		const canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
		if (canonicalLink) {
			const canonicalUrl = new URL(canonicalLink.href);
			if (page === "1") {
				canonicalUrl.searchParams.delete('page');
			} else {
				canonicalUrl.searchParams.set('page', page);
			}
			canonicalLink.href = canonicalUrl.toString();
		}
	}

}
